import type { UserRevokedAction } from '@Application/Security/Authentications/Actions/userRevoked';
import type { AiUsagesFetchedAction } from '@Application/Ai/AiUsages/Actions/aiUsagesFetched';
import LabeledValueView from '@UI/Store/Shared/Views/LabeledValueView';
import { createSliceReducer, registerStore } from '@verclam/synapse';

export type AiUsagesStore = {
	aiUsages: readonly LabeledValueView[] | null;
};

const initialState: AiUsagesStore = {
	aiUsages: null,
};

type Actions = AiUsagesFetchedAction | UserRevokedAction;

const whenAiUsagesFetched = (store: AiUsagesStore, action: AiUsagesFetchedAction): AiUsagesStore => ({
	...store,
	aiUsages: action.payload.map((entry) => new LabeledValueView(entry)),
});

// A catalog of labels has no reason to survive a session: the next session refetches it.
const whenUserRevoked = (): AiUsagesStore => initialState;

export default registerStore<'aiUsagesStore', Actions>(
	'aiUsagesStore',
	createSliceReducer({
		AI_USAGES_FETCHED: whenAiUsagesFetched,
		USER_REVOKED: whenUserRevoked,
	}),
	initialState,
);
